// type 1 all  全部有
// type 2 或  有其中一个就渲染
// type 3 递归list 或
// 带参数的url需要校验 有全国分布,农作物分布,设备分布

const authConfig = {
  // 系统首页
  "system-index": { type: 1, list: [] },
  // 全国分布
  "digital-baseland-distribute-country": {
    type: 2,
    list: [
      "digital-baseland-distribute-country-type1-query",
      "digital-baseland-distribute-country-type2-query",
      "digital-baseland-distribute-country-type3-query",
      "digital-baseland-distribute-country-type4-query"
    ]
  },
  // 农作物分布
  "digital-baseland-distribute": {
    type: 2,
    list: [
      "digital-baseland-distribute-type1-query",
      "digital-baseland-distribute-type2-query",
      "digital-baseland-distribute-type3-query",
      "digital-baseland-distribute-type4-query",
      "digital-baseland-distribute-type5-query",
      "digital-baseland-distribute-type6-query"
    ]
  },
  // 'baseland-distribute-type-1': {
  //   type: 1,
  //   list: []
  // },
  // 'baseland-distribute-type-2': {
  //   type: 1,
  //   list: []
  // },
  // 'baseland-distribute-type-3': {
  //   type: 1,
  //   list: []
  // },
  // 'baseland-distribute-type-4': {
  //   type: 1,
  //   list: []
  // },
  // 'baseland-distribute-type-5': {
  //   type: 1,
  //   list: []
  // },
  // 'baseland-distribute-type-6': {
  //   type: 1,
  //   list: []
  // },
  // 数字基地
  "digital-baseland": {
    type: 3,
    list: [
      "digital-baseland-list",
      "baseland-new",
      "digital-baseland-rating",
      "digital-baseland-setting"
    ]
  },
  // 数字基地-列表
  "digital-baseland-list": {
    type: 2,
    list: [
      "digital-baseland-list-add",
      "digital-baseland-list-query",
      "digital-baseland-list-detail",
      "digital-baseland-list-update",
      "digital-baseland-list-delete"
    ]
  },
  // 数字基地-新增
  "baseland-new": {
    type: 1,
    list: ["digital-baseland-list-add"]
  },
  // 数字基地-基地评级报表
  "digital-baseland-rating": {
    type: 2,
    list: ["digital-baseland-rating-query"]
  },
  // 数字基地-基地评级 ?有编辑没查看?   ->只对编辑判断
  "digital-baseland-setting": {
    type: 2,
    list: ["digital-baseland-setting-query", "digital-baseland-setting-update"]
  },
  // 设备管理
  "device-manage": {
    type: 3,
    list: [
      "device-manage-binduser",
      "device-manage-distribute",
      "device-manage-video",
      "device-manage-product",
      "device-manage-fertigation",
      "device-manage-Drones"
    ]
  },
  "device-manage-binduser": {
    type: 2,
    list: ["device-manage-binduser-query", "device-manage-binduser-bind"]
  },
  // 产品管理-产品中心
  "device-manage-product": {
    type: 2,
    list: [
      "device-manage-product",
      "device-manage-view",
      // "device-manage-list",
      "device-manage-data",
      "device-manage-command"
    ]
  },
  // 产品管理-设备导入
  "device-management-info": {
    type: 2,
    list: [
      "device-management-info-query",
      "device-management-info-import",
      "device-management-info-updatebind"
    ]
  },
  // 产品管理-设备列表
  "device-manage-list": {
    type: 2,
    list: [
      "device-manage-list-query",
      "device-manage-list-bind",
      "device-manage-list-allocate",
      "device-manage-list-import",
      "device-manage-list-command",
      "device-manage-list-detail",
      "device-manage-list-updatename",
      "device-manage-list-delete"
    ]
  },
  // 产品管理-设备数据
  "device-manage-data": {
    type: 1,
    list: ["device-manage-data-query"]
  },

  // 产品管理-分布
  "device-manage-distribute": {
    type: 1,
    list: ["device-manage-distribute"]
  },
  // 农业标准库
  "agriculture-database": {
    type: 3,
    list: [
      "agriculture-database-crop",
      "agriculture-database-disaster",
      "agriculture-database-farmtype"
    ]
  },
  // 农业标准库-农作物
  "agriculture-database-crop": {
    type: 2,
    list: [
      "agriculture-database-crop-switch",
      "agriculture-database-crop-add",
      "agriculture-database-crop-query",
      "agriculture-database-crop-detail",
      "agriculture-database-crop-update",
      "agriculture-database-crop-delete",
      "agriculture-database-crop-import",
      "agriculture-database-crop-download"
    ]
  },
  // 农业标准库-病虫害
  "agriculture-database-disaster": {
    type: 2,
    list: [
      "agriculture-database-disaster-add",
      "agriculture-database-disaster-query",
      "agriculture-database-disaster-detail",
      "agriculture-database-disaster-update",
      "agriculture-database-disaster-delete",
      "agriculture-database-disaster-import",
      "agriculture-database-disaster-switch"
    ]
  },
  // 农业标准库-农业分类
  "agriculture-database-farmtype": {
    type: 2,
    list: [
      "agriculture-database-farmtype-add",
      "agriculture-database-farmtype-query",
      "agriculture-database-farmtype-detail",
      "agriculture-database-farmtype-update",
      "agriculture-database-farmtype-delete",
      "agriculture-database-farmtype-import",
      "agriculture-database-farmtype-switch"
    ]
  },
  // 生产管理
  "production-manage": {
    type: 3,
    list: [
      "production-manage-farmtype",
      "production-manage-farmrecord",
      "production-manage-farmplan"
    ]
  },
  // 生产管理--农事分类
  "production-manage-farmtype": {
    type: 2,
    list: [
      "production-manage-farmtype-add",
      "production-manage-farmtype-query",
      "production-manage-farmtype-detail",
      "production-manage-farmtype-update",
      "production-manage-farmtype-deletet"
    ]
  },
  // 生产管理--农事记录
  "production-manage-farmrecord": {
    type: 2,
    list: [
      "production-manage-farmrecord-add",
      "production-manage-farmrecord-query",
      "production-manage-farmrecord-detail",
      "production-manage-farmrecord-update",
      "production-manage-farmrecord-deletet"
    ]
  },
  // 生产管理--农事计划
  "production-manage-farmplan": {
    type: 2,
    list: [
      "production-manage-farmplan-add",
      "production-manage-farmplan-query",
      "production-manage-farmplan-detail",
      "production-manage-farmplan-update",
      "production-manage-farmplan-deletet"
    ]
  },
  // 用户管理
  "user-manage": {
    type: 3,
    list: ["user-management-info", "user-management-register"]
  },
  "user-management-info": {
    type: 2,
    list: ["user-management-info-query", "user-management-info-detail"]
  },
  "user-management-register": {
    type: 1,
    list: ["user-management-register"]
  },
  // 数据报表
  "data-report": {
    type: 3,
    list: ["statistic-report-cropwarning", "statistic-report-soil"]
  },
  // 数据报表-作物监测报表
  "statistic-report-cropwarning": {
    type: 2,
    list: ["statistic-report-cropwarning"]
  },
  // 数据报表-土壤分级报表
  "statistic-report-soil": {
    type: 2,
    list: ["statistic-report-soil"]
  },
  // 机构管理
  "mechanism-manage": {
    type: 3,
    list: [
      "mechanism-management-info",
      "mechanism-management-dept",
      "mechanism-management-info-add"
    ]
  },
  // 机构管理-机构列表
  "mechanism-management-info": {
    type: 2,
    list: [
      "mechanism-management-info-add",
      "mechanism-management-info-query",
      "mechanism-management-info-detail",
      "mechanism-management-info-update",
      "mechanism-management-info-delete",
      "mechanism-management-info-import"
    ]
  },
  // 机构管理-部门管理
  "mechanism-management-dept": {
    type: 2,
    list: [
      "mechanism-management-dept-add",
      "mechanism-management-dept-query",
      "mechanism-management-dept-update",
      "mechanism-management-dept-delete"
    ]
  },
  "mechanism-management-info-add": {
    type: 1,
    list: ["mechanism-management-info-add"]
  },
  // 系统管理
  "system-manage": {
    type: 3,
    list: ["system-manage-role", "system-manage-account"]
  },
  // 系统管理-角色管理
  "system-manage-role": {
    type: 2,
    list: [
      "system-manage-role-add",
      "system-manage-role-query",
      "system-manage-role-detail",
      "system-manage-role-update"
      // 'system-manage-role-switch'
    ]
  },
  // 系统管理-账号管理
  "system-manage-account": {
    type: 2,
    list: [
      "system-manage-account-add",
      "system-manage-account-query",
      "system-manage-account-detail",
      "system-manage-account-update",
      "system-manage-account-switch"
    ]
  },
  // 应用服务
  "application-service": {
    type: 3,
    list: [
      "application-service-setting",
      "application-service-order",
      "application-service-purchase"
    ]
  },
  // 应用服务-套餐配置
  "application-service-setting": {
    type: 2,
    list: [
      "application-service-setting-list",
      "application-service-setting-add",
      "application-service-setting-update",
      "application-service-setting-switch",
      "application-service-setting-detail"
    ]
  },
  // 应用服务-订单信息
  "application-service-order": {
    type: 1,
    list: ["application-service-order-list"]
  },
  // 应用服务-订购服务
  "application-service-purchase": {
    type: 1,
    list: ["application-service-purchase-list"]
  },
  // 基础设置
  "basic-setting": {
    type: 3,
    list: ["basic-setting-param"]
  },
  // 基础设置 -参数设置
  "basic-setting-param": {
    type: 2,
    list: [
      "basic-setting-param-add",
      "basic-setting-param-update",
      "basic-setting-param-list",
      "basic-setting-param-switch"
    ]
  },
  // 产品管理
  "product-goods": {
    type: 2,
    list: [
      "product-goods-add",
      "product-goods-update",
      "product-goods-delete",
      "product-goods-detail",
      "product-goods-query"
    ]
  },
  // 批次列表
  "product-batch": {
    type: 2,
    list: [
      "product-batch-add",
      "product-batch-update",
      "product-batch-delete",
      "product-batch-detail",
      "product-batch-query",
      "product-batch-addCode",
      "product-batch-settings"
    ]
  },
  // 溯源码列表
  "product-code": {
    type: 2,
    list: [
      "product-code-query",
      "product-code-delete",
      "product-code-detail",
      "product-code-down"
    ]
  },
  // 认证信息
  "traceability-certification": {
    type: 2,
    list: [
      "traceability-certification-add",
      "traceability-certification-update",
      "traceability-certification-delete",
      "traceability-certification-detail",
      "traceability-certification-query"
    ]
  },
  // 视频管理
  "device-manage-video": {
    type: 2,
    list: [
      "device-manage-video-watch",
      "device-manage-video-allot",
      "device-manage-video-query",
      "device-manage-video-add"
    ]
  },
  // 专家答疑
  "expert-questions": {
    type: 2,
    list: [
      "expert-question-list",
      "expert-questions-reply",
      "expert-questions-distribute"
    ]
  },
  // 面源数据库
  "areaSource-dataBase": {
    type: 3,
    list: [
      "areaSource-dataBase-record",
      "areaSource-dataBase-viewData",
      "areaSource-dataBase-check"
    ]
  },
  // 面源数据库-数据录入
  "areaSource-dataBase-record": {
    type: 2,
    list: [
      "areaSource-dataBase-record-add",
      "areaSource-dataBase-record-download",
      "areaSource-dataBase-record-update",
      "areaSource-dataBase-record-delete",
      "areaSource-dataBase-record-detail",
      "areaSource-dataBase-record-query"
    ]
  },
  // 面源数据库-查看数据
  "areaSource-dataBase-viewData": {
    type: 2,
    list: [
      "areaSource-dataBase-viewData-add",
      "areaSource-dataBase-viewData-update",
      "areaSource-dataBase-viewData-delete",
      "areaSource-dataBase-viewData-detail",
      "areaSource-dataBase-viewData-query"
    ]
  },
  // 面源数据库-检查项目
  "areaSource-dataBase-check": {
    type: 2,
    list: [
      "areaSource-dataBase-check-query",
      "areaSource-dataBase-check-delete",
      "areaSource-dataBase-check-detail",
      "areaSource-dataBase-check-update"
    ]
  },
  // 面源分析
  "areaSource-analyze": {
    type: 3,
    list: [
      "areaSource-nemerow",
      "areaSource-soilNutrient",
      "areaSource-special"
    ]
  },
  // 面源分析-内梅罗指数
  "areaSource-nemerow": {
    type: 2,
    list: ["areaSource-nemerow-list", "areaSource-nemerow-edit"]
  },
  // 面源分析-土壤营养分级
  "areaSource-soilNutrient": {
    type: 2,
    list: ["areaSource-soilNutrient-query", "areaSource-soilNutrient-update"]
  },
  // 面源分析-防治专题
  "areaSource-special": {
    type: 5,
    list: [
      "areaSource-special-query",
      "areaSource-special-update",
      "areaSource-special-add",
      "areaSource-special-delete",
      "areaSource-special-overview"
    ]
  }
};

// digital-baseland-distribute-country
// digital-baseland-distribute
export const routerAuth = {
  // 系统首页
  "/main/plant/base": {
    type: "query",
    field: "crop",
    list: {
      1: "digital-baseland-distribute-country-type1-query",
      2: "digital-baseland-distribute-country-type2-query",
      3: "digital-baseland-distribute-country-type3-query",
      4: "digital-baseland-distribute-country-type4-query"
    }
  },
  // 农作物分布
  // '/main/crop/distribute/5/大田类',
  // '/main/crop/distribute/6/茄瓜类',
  // '/main/crop/distribute/7/瓜豆类',
  // '/main/crop/distribute/8/块根类',
  // '/main/crop/distribute/9/叶菜类',
  // '/main/crop/distribute/163/果树类',
  "/main/plant/crop/distribute/:id/:name": {
    type: "params",
    field: "id",
    list: {
      5: "digital-baseland-distribute-type1-query",
      163: "digital-baseland-distribute-type2-query",
      6: "digital-baseland-distribute-type3-query",
      7: "digital-baseland-distribute-type4-query",
      8: "digital-baseland-distribute-type5-query",
      9: "digital-baseland-distribute-type6-query"
    }
  },
  "/main/crop/knowledge/:id": "",
  "/main/crop/nutrition/:id": "",
  // 数字基地
  "/main/public/baseland/detail/:id": "",
  "/main/public/baseland/plantmanage/:id": "",
  "/main/public/baseland/add": "digital-baseland-list-add",
  "/main/public/baseland/list": "digital-baseland-list",
  "/main/public/baseland/info/:id": "digital-baseland-list-query",
  "/main/public/baseland/edit/:id": "digital-baseland-list-update",
  "/main/public/baseland/baseRating": "digital-baseland-rating-query",
  // 运营配置
  "/main/settings/configure/rate": "digital-baseland-setting",
  // 运营管理--基础设置
  "/main/settings/configure/package/list": "basic-setting",

  // 设备管理
  "/main/plant/device/equipList/list": "device-manage-binduser",
  "/main/plant/device/Distribution/list": "device-manage-distribute",
  "/main/plant/device/equipmentInfo/list": "device-management-info",
  "/main/plant/device/productcenter/list": "device-manage-product",
  // 标准数据库
  "/main/plant/bigData/crop/list": "agriculture-database-crop",
  "/main/plant/bigData/crop/info/:id": "agriculture-database-crop-detail",
  "/main/plant/bigData/illness/list": "agriculture-database-disaster",
  "/main/plant/bigData/illness/form": {
    type: "query",
    list: {
      view: "agriculture-database-disaster-detail",
      add: "agriculture-database-disaster-add",
      update: "agriculture-database-disaster-update"
    }
  },
  "/main/plant/bigData/cat/list": "agriculture-database-farmtype",
  "/main/plant/bigData/cat/form": {
    type: "query",
    list: {
      view: "agriculture-database-farmtype-detail",
      add: "agriculture-database-farmtype-add",
      update: "agriculture-database-farmtype-update"
    }
  },

  /**
   * 生产管理
   * */

  // 农事记录
  "/main/plant/farmwork/record/list": "production-manage-farmrecord",
  "/main/plant/farmwork/record/form": {
    type: "query",
    list: {
      view: "production-manage-farmrecord-detail",
      add: "production-manage-farmrecord-add",
      update: "production-manage-farmrecord-update"
    }
  },
  // 农事计划
  "/main/public/farmwork/plan/list": "production-manage-farmplan",
  "/main/public/farmwork/plan/form": {
    type: "query",
    list: {
      view: "production-manage-farmplan-detail",
      add: "production-manage-farmplan-add",
      update: "production-manage-farmplan-update"
    }
  },
  "/main/public/farmwork/cat": "production-manage-farmtype",
  "/main/public/farmwork/detail/:id": "production-manage-farmtype-detail",
  "/main/public/farmwork/form": {
    type: "query",
    list: {
      view: "production-manage-farmtype-detail",
      add: "production-manage-farmtype-add",
      update: "production-manage-farmtype-update"
    }
  },

  // 数据报表
  "/main/plant/cropMornitorReport/soilRate": "statistic-report-soil",
  "/main/plant/cropMornitorReport/cropReport": "statistic-report-cropwarning",
  "/main/plant/cropMornitorReport/detail/:id/:startDate/:endDate/:baselands/:name":
    "",

  // 用户管理
  "/main/plant/userManage/list": "user-management-info",
  "/main/plant/userManage/details/:id": "user-management-info-detail",
  "/main/plant/userManage/register": "user-management-register",
  // 机构管理
  "/main/plant/organization/team/list": "mechanism-management-info",
  "/main/plant/organization/team/form": {
    type: "query",
    list: {
      view: "mechanism-management-info-detail",
      add: "mechanism-management-info-add",
      update: "mechanism-management-info-update"
    }
  },
  "/main/plant/organization/department/list": "mechanism-management-dept",
  "/main/plant/organization/department/form": {
    type: "query",
    list: {
      view: "mechanism-management-dept-detail",
      add: "mechanism-management-dept-add",
      update: "mechanism-management-dept-update"
    }
  },
  // 系统管理
  "/main/system/public/role/list": "system-manage-role",
  "/main/system/public/role/form": {
    type: "query",
    list: {
      view: "system-manage-role-detail",
      add: "system-manage-role-add",
      update: "system-manage-role-update"
    }
  },
  "/main/system/public/account/list": "system-manage-account",
  "/main/system/public/account/form": {
    type: "query",
    list: {
      view: "system-manage-account-detail",
      add: "system-manage-account-add",
      update: "system-manage-account-update"
    }
  },
  // 应用服务
  // 套餐配置
  // '/main/settings/configure/package/list': 'application-service-setting',
  "/main/settings/configure/package/form": {
    type: "query",
    list: {
      view: "application-service-setting-detail",
      add: "application-service-setting-add",
      update: "application-service-setting-update"
    }
  },
  // 订单信息
  "/main/settings/configure/order/list": "application-service-order",
  // 订购服务
  "/main/plant/service/mypackage/list": "application-service-purchase",
  // 溯源系统
  // 产品管理-产品信息
  "/main/source/product/goods/list": "product-goods",
  "/main/source/product/goods/form": {
    type: "query",
    list: {
      view: "product-goods-detail",
      add: "product-goods-add",
      update: "product-goods-update"
    }
  },
  // 产品管理-批次管理
  "/main/source/product/batch/list": "product-batch",
  "/main/source/product/batch/form": {
    type: "query",
    list: {
      view: "product-batch-detail",
      add: "product-batch-add",
      update: "product-batch-update"
    }
  },
  "/main/source/product/batch/settings": "product-batch-settings",
  // 产品管理-溯源码管理
  "/main/source/product/code/list": "product-code",
  // 溯源数据-监测数据
  "/main/source/traceability/code/list": "traceability-data-query",
  // 溯源数据-认证信息
  "/main/source/traceability/authentication/list": "traceability-certification",
  "/main/source/traceability/authentication/form": {
    type: "query",
    list: {
      add: "traceability-certification-add",
      update: "traceability-certification-update"
    }
  },
  // 视频管理
  "/main/plant/device/videoManage/list": "device-manage-video",
  "/main/plant/device/videoManage/video": "device-manage-video-watch",
  // 专家答疑
  "/main/professor/expert/questions/list": "expert-questions",
  // 面源数据库-数据录入
  "/main/area/areaSource/AreaData": "areaSource-dataBase-record",
  // 面源数据库-查看数据
  "/main/area/areaSource/viewData": "areaSource-dataBase-viewData",
  // 面源数据库-检查项目
  "/main/area/areaSource/checkItem/list": "areaSource-dataBase-check",
  // 面源分析-内梅罗指数
  "/main/area/sourceAnalysis/nemerowIndex/list": "areaSource-nemerow",
  // 面源分析-土壤营养分级
  "/main/area/sourceAnalysis/soilNutrient/list": "areaSource-soilNutrient",
  // 面源分析-防治专题
  "/main/area/sourceAnalysis/special/list": "areaSource-special"
};

export default authConfig;
